import { AxiosError, isAxiosError } from "axios";


export default function throwIfCanceled(err: any) {
  if (isAxiosError(err) && (err.code === AxiosError.ERR_CANCELED)) {
    // the react router will handle (ignore) this
    throw err;
  }
};
